import { calculateQuote, getAddon } from '@estac1/shared';
import type { Lot, PricingSettings, StatusFilter } from './types.js';

export const FILTERS: Array<{ id: StatusFilter; label: string }> = [
  { id: 'all', label: 'Todos' },
  { id: 'active', label: 'Ativos' },
  { id: 'trial', label: 'Em teste' },
  { id: 'past_due', label: 'Atrasados' },
  { id: 'archived', label: 'Arquivados' },
];

export const formatDate = (raw: string | null) =>
  raw
    ? new Date(raw).toLocaleDateString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      })
    : '—';

export const statusVariant = (s: string | null): 'success' | 'default' | 'danger' => {
  if (s === 'active') return 'success';
  if (s === 'past_due' || s === 'canceled') return 'danger';
  return 'default';
};

export const mrrForLot = (lot: Lot, pricing: PricingSettings | undefined): number | null => {
  if (!pricing || lot.vacancies == null || lot.vacancies <= 0) return null;
  const quote = calculateQuote({
    vacancies: lot.vacancies,
    tiers: pricing.tiers,
    minimumCents: pricing.minimumCents,
    maxVacancies: pricing.maxVacancies,
  });
  if (!quote.ok) return null;
  const damagePhotosCents = getAddon('damage_photos')?.priceCents ?? 0;
  return quote.totalCents + (lot.damagePhotosEnabled ? damagePhotosCents : 0);
};
